import React, { forwardRef } from 'react';

import {
  UserAuthHandlerMachineSendType,
  UserAuthHandlerMachineStateType
} from '@nw/client-auth-manager';
import { WhirlArrowIcon } from '@nw/shared/ui';

import { FormSectionId } from '../../constants/LoginPage';
import LoginCard from '../../LoginCard';

import {
  SignupFormHeading,
  SignupFormWrapper,
  WhirlArrowContainer
} from './styledComponent';

interface LoginPageProps {
  onSuccessfulLogin: (
    userAuthHandlerMachineState: UserAuthHandlerMachineStateType
  ) => void;
  userAuthHandlerMachineState: UserAuthHandlerMachineStateType;
  userAuthHandlerMachineSend: UserAuthHandlerMachineSendType;
}

const LandingSectionDM = forwardRef<HTMLDivElement, LoginPageProps>(
  (
    {
      onSuccessfulLogin,
      userAuthHandlerMachineState,
      userAuthHandlerMachineSend
    },
    ref
  ): JSX.Element => {
    const renderSignupForm = (): JSX.Element => (
      <SignupFormWrapper id={FormSectionId} ref={ref}>
        <SignupFormHeading>Book your NAT Slot in 2 mins</SignupFormHeading>
        <LoginCard
          onSuccessfulLogin={onSuccessfulLogin}
          userAuthHandlerMachineState={userAuthHandlerMachineState}
          userAuthHandlerMachineSend={userAuthHandlerMachineSend}
        />
        <WhirlArrowContainer>
          <WhirlArrowIcon />
        </WhirlArrowContainer>
      </SignupFormWrapper>
    );

    return <>{renderSignupForm()}</>;
  }
);

export default LandingSectionDM;
